import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { ButtonRowDirective } from './button-row.directive';
import { ButtonDirective } from './button.directive';

/**
 * @deprecated This should not be used. Instead, consider using IrisButtonModule
 */
@NgModule({
  imports: [
    MatButtonModule,
    MatIconModule,
  ],
  declarations: [
    ButtonDirective,
    ButtonRowDirective,
  ],
  exports: [
    ButtonDirective,
    ButtonRowDirective,
  ]
})
export class ButtonsModule {
}
